module.exports = __webpack_public_path__ + "kudos_44.svg?39426386b739ec9928fe24fd14cae261";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_44.svg
// module id = 144
// module chunks = 0